<template>
<div class="guts">
  <v-tabs
    dark
    color="#1C4680"
    show-arrows
    v-if="$vuetify.breakpoint.xsOnly"
    px-0
    mx-0
    centered
    v-model="listShowing"
  >
    <v-tabs-slider color="accent" ></v-tabs-slider>

    <v-tab
      v-for="(list, index) in lists"
      :key="index"
      @click="showList(index)"
      :id="`tab${index}`"
      style="font-size:1rem; text-transform:lowercase; font-weight:700;"
    >
      {{ list.title }}
    </v-tab>
  </v-tabs>
    <div class="lists" :class="`listshowing${listShowing}`">
      <column
        v-for="(list, index) in lists"
        :key="index"
        :listId="index + 1"
        :id="`list${index + 1}`"
        :showTotals="showTotals"
        :name="list.title"
        >
      </column>
    </div>
    <div class="board-footer">
      <v-btn class="totalsbut" small flat @click='toggleTotals()' data-v-step="totalsbut">Totals</v-btn>
      <!----<div class="job-filter">
        <input type="search" v-model="jobFilter" id="job-filter" name="job-filter" placeholder="Filter jobs" clearable>
        <button v-if="jobFilter != ''" class="job-filter-clear" @click="jobFilter = ''">x</button>
      </div>-->
    </div>
    <split-invoice-modal></split-invoice-modal>
    <job-detail-modal></job-detail-modal>
</div>
</template>

<script>
import Column from '@/components/Board/Column'
import SplitInvoiceModal from '@/components/Shared/SplitInvoiceModal'
import JobDetailModal from '@/components/Shared/JobDetailModal'

export default {
  components: {
    Column,
    SplitInvoiceModal,
    JobDetailModal
  },
  data () {
    return {
      lists: [
        { title: 'Leads' },
        { title: 'Confirmed' },
        { title: 'Current' },
        { title: 'Invoiced' },
        { title: 'Paid' }
      ],
      rightDrawer: false,
      showTotals: false,
      listShowing: 2
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    barHeight () {
      if (this.$vuetify.breakpoint.mdAndDown) {
        return 60
      } else {
        return 40
      }
    },
    jobFilter: {
      get () { return this.$store.state.jobFilter },
      set (value) { this.$store.commit('setJobFilter', value) }
    }
  },
  methods: {
    toggleTotals () {
      this.showTotals = !this.showTotals
    },
    showList (listNumber) {
      console.log(listNumber)
      localStorage.setItem('mob-list', listNumber)

      this.listShowing = listNumber
    }
  },
  mounted () {
    if (localStorage.getItem('mob-list')) {
      this.listShowing = parseInt(localStorage.getItem('mob-list'))
    }
  },
  beforeRouteLeave (to, from, next) {
    // used to ensure the intro tour stops when we navigate away from the Dash
    this.$emit('stopTour')
    next()
  }
}
</script>

<style lang="scss">
.lists{
  display: flex;
  overflow-x: auto;
  flex:1;
  > * {
    flex: 0 0 auto;
  }
}
.xsOnly{
  .col-holder{
    display:none;
  }
  .listshowing0{
    #list1{
      display:flex;
    }
  }
  .listshowing1{
    #list2{
      display:flex;
    }
  }
  .listshowing2{
    #list3{
      display:flex;
    }
  }
  .listshowing3{
    #list4{
      display:flex;
    }
  }
  .listshowing4{
    #list5{
      display:flex;
    }
  }
}
.guts{
  background:var(--background-grey);
  padding:0;
  // height:calc(100vh - 70px);
  // make this a flexbox item that fills the height of the parent
  // make this a flexbox container
  display:flex;
  flex-direction:column;
  height:100%;
  // height:calc(100dvh - 35px);
  height:calc(100dvh - 50px);
}
.condensed .guts{
  height:calc(100dvh - 40px);
}

.board-footer{
  position: relative;
  display:flex;
  justify-content:center;
  align-items: center;
  background:var(--mutedprimary);
  // height:40px;
  height:50px;
}
.condensed .board-footer{
  height:40px;
}
.touch .totalsbut{
  margin-top:-10px;

}
.totalsbut{
  margin-top:0;
  font-size:1rem !important;
  text-transform:capitalize;
  font-weight:700;
  background-color: var(--totals-button) !important;
  color:#fff !important;
  // background-color:rgba(140,209,61, 1) !important;
  opacity:1;
  border-radius:3px;
  &:hover{
      background-color:var(--green) !important;
      opacity:1;

  }
}
.job-filter{
  position:absolute;
  left:10px;
  input{
    background:#fff;
    border-radius:5px;
    padding:2px 8px;
    opacity:.5;
    transition: opacity 100ms;
    &:focus{
      opacity:1;
      outline:none;
      width:250px;

    }
  }
  .job-filter-clear{
    position: absolute;
    right:5px;
    width:8px;
  }
}
.xsOnly{
  .job-filter{
    display:none;
  }
}

</style>
